import { supportsFlags } from './basler-components.es798.js';
import { memo } from './basler-components.es776.js';

function memoSupports(callback, supportsFlag) {
    const memoized = memo(callback);
    return () => supportsFlags[supportsFlag] ?? memoized();
}

export { memoSupports };
